import { createIcon } from '@chakra-ui/react';

export default createIcon({
  displayName: 'InfoIcon',
  viewBox: '0 0 16 16',
  defaultProps: {
    boxSize: 4,
  },
  path: (
    <path
      d="m7.5 7.5.028-.014a.5.5 0 0 1 .708.569l-.472 1.89a.5.5 0 0 0 .708.569L8.5 10.5M14 8A6 6 0 1 1 2 8a6 6 0 0 1 12 0M8 5.5h.005v.005H8z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      fill="none"
    />
  ),
});
